import React, { useContext } from 'react';

import { Resource } from '../../../../common/constants/resource';
import { FeatureFlagsContext } from '../../../../common/featureFlagsWrapper';
import { MVR } from '../../../tasks/types/mvr';
import { RenderApplicantSection } from './MVRApplicantSection';
import { RenderMVRDriverRecordSection } from './MVRDriverRecordSection';
import { RenderMVRLicenseInfoSection } from './MVRLicenseInfoSection';
import { RenderMVRMiscellaneousSection } from './MVRMiscellaneousSection';
import { MVRRedesignPanel } from './MVRRedesignPanel';

/**
 * Shared MVR details renderer used by both the detail and PPWB MVR views.
 * Renders the feature-flagged redesign when enabled, otherwise the legacy
 * sections (unchanged behaviour).
 */
export const MVRDetailsBody = ({
  mvr,
  errorMessage,
  evidenceId,
}: {
  mvr: MVR | null;
  errorMessage?: string;
  evidenceId?: number;
}) => {
  const { flags } = useContext(FeatureFlagsContext);

  if (flags.isMvrRedesignEnabled) {
    return (
      <MVRRedesignPanel
        mvr={mvr}
        errorMessage={errorMessage}
        evidenceId={evidenceId}
      />
    );
  }

  return (
    <>
      {mvr && mvr.recordClear && <p>{Resource.MVR_CLEAR}</p>}
      {mvr && !mvr.recordClear && !mvr.recordExists && !errorMessage && (
        <p>{Resource.MVR_NO_RECORD}</p>
      )}
      {mvr &&
        mvr.recordExists &&
        mvr.applicant &&
        RenderApplicantSection(mvr.applicant)}
      {mvr &&
        mvr.recordExists &&
        mvr.licenseInfo &&
        RenderMVRLicenseInfoSection(mvr.licenseInfo)}
      {mvr &&
        mvr.recordExists &&
        mvr.driverRecord &&
        RenderMVRDriverRecordSection(mvr.driverRecord)}
      {mvr &&
        mvr.recordExists &&
        mvr.miscellaneous &&
        RenderMVRMiscellaneousSection(mvr.miscellaneous)}
    </>
  );
};
